import React, { useState, useEffect, useRef } from 'react';
import Calendar from '../Calendar/Calendar.js';
import {
  startOfWeek,
  endOfWeek,
  eachDayOfInterval,
  format
} from 'date-fns';
import { ptBR } from 'date-fns/locale';
import './WeekSelector.css';
import { useTranslation } from 'react-i18next';
import Translator from '../I18n/Translator';
import { t } from 'i18next';
import { getEpidemiologicalWeek } from '../EpidemiologicalWeek';

const WeekSelector = ({ onWeekChange, initialDate, finalDate,semanaSelecionada}) => {
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const comboboxRef = useRef(null);
  const calendarRef = useRef(null);
    const { t } = useTranslation();

  // Função para calcular a semana epidemiológica usando moment.js
  /*const getEpidemiologicalWeek = (date) => {
    

    const sunday = startOfWeek(date, { weekStartsOn: 0 });
    const mom = moment(sunday);
    return { year: mom.weekYear(), week: mom.week() };
  };*/



  // Função para obter o domingo da semana de uma data usando date-fns
  const getSundayOfWeek = (date) => {
    return startOfWeek(date, { weekStartsOn: 0 }); // 0 para domingo
  };

  // Função para obter o sábado da semana de uma data usando date-fns
  const getSaturdayOfWeek = (date) => {
    return endOfWeek(date, { weekStartsOn: 0 }); // 0 para domingo
  };

  // Função para criar dados completos da semana
  const createWeekData = (date) => {
    const sunday = getSundayOfWeek(date);
    const saturday = getSaturdayOfWeek(date);
    const epidWeek = getEpidemiologicalWeek(date);
    
    const weekData = {
      sunday,
      saturday,
      epidemiologicalWeek: epidWeek,
      dates: eachDayOfInterval({ start: sunday, end: saturday })
    };
    
    return weekData;
  };

  // Inicializar com a semana atual
  useEffect(() => {
  const weekData = createWeekData(new Date('2017-01-01'));
  setSelectedWeek(weekData);
}, []);

useEffect(() => {
  if(semanaSelecionada != null) {
    setSelectedWeek(semanaSelecionada)
  }

},[semanaSelecionada])


  // Função para formatar a exibição da semana
  const formatWeekDisplay = (weekData) => {
    if (!weekData) return 'Selecione uma semana...';
    
    const { epidemiologicalWeek, sunday, saturday } = weekData;
    const startDate = format(sunday, 'dd/MM', { locale: ptBR });
    const endDate = format(saturday, 'dd/MM', { locale: ptBR });
    const weekStr = String(epidemiologicalWeek.week).padStart(2, '0');
    
    return `${t('dashboard.calendar.sigle_se')} ${weekStr}-${epidemiologicalWeek.year} (${startDate} - ${endDate})`;
  };

  // Função para abrir/fechar o calendário
  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };

  // Função chamada quando uma semana é selecionada no calendário
  const handleWeekSelect = (weekData) => {
    setSelectedWeek(weekData);
    setIsCalendarOpen(false);
    
    if (onWeekChange) {
      onWeekChange(weekData);
    }
  };

  // Função para fechar o calendário ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current && 
        !calendarRef.current.contains(event.target) &&
        comboboxRef.current &&
        !comboboxRef.current.contains(event.target)
      ) {
        setIsCalendarOpen(false);
      }
    };

    if (isCalendarOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isCalendarOpen]);

  // Função para fechar com ESC
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        setIsCalendarOpen(false);
      }
    };

    if (isCalendarOpen) {
      document.addEventListener('keydown', handleEscKey);
      return () => {
        document.removeEventListener('keydown', handleEscKey);
      };
    }
  }, [isCalendarOpen]);

  return (
    <div className="week-selector">
      {/* <div className="week-selector-label">
        <span>{t('dashboard.semana_ep')}:</span>
      </div> */}
      
      <div 
        ref={comboboxRef}
        className={`week-selector-combobox ${isCalendarOpen ? 'open' : ''}`}
        onClick={toggleCalendar}
      >
        <div className="week-selector-value">
          {formatWeekDisplay(selectedWeek)}
        </div>
        <div className="week-selector-arrow">
<svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowDropDownIcon"><path d="M7 10l5 5 5-5z"></path></svg>        </div>
      </div>

      {isCalendarOpen && (
        <>
          <div className="week-selector-overlay" />
          <div ref={calendarRef} className="week-selector-calendar">
            <div className="week-selector-calendar-header">
              <h3>{t('dashboard.calendar.titulo_se_selected')}</h3>
              <button 
                className="week-selector-close"
                onClick={() => setIsCalendarOpen(false)}
              >
                ×
              </button>
            </div>
            <Calendar 
              onWeekSelect={handleWeekSelect}
              isFloating={true}
              selectedWeek={selectedWeek}
              initialDate={initialDate}
              finalDay={finalDate}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default WeekSelector;


